export const excelColList: string[] = [
  'ApplicationId',
  'caseNum',
  'dateReceived',
  'applicantName',
  'applicantStrAddr',
  'applicantCity',
  'applicantState',
  'applicantZip',
  'agencyName',
  'agencyContact',
  'agencyStrAddr',
  'agencyCity',
  'agencyState',
  'agencyZip',
  'propStrNum',
  'propStreet',
  'propCity',
  'propAPN',
  'propUnsecuredNum',
  'propType',
  'dateClosed',
  'propSecured',
  'propTaxRateArea',
  'dateConfirmationReceived',
  'propUseCode',
  'waiverReceived',
  'waiverExpDate',
  'claimRefund',
  'status',
  'subStatus',
  'statusDate',
  'hearingId',
  'hearingDate',
  'closedStatus',
  'specialCase',
  'division',
  'crew',
  'comments',
  'appraiserId',
  'appraiserName',
  'complexCase',
  'assessType',
  'propRollYear',
  'propOwnOccupy',
  'tvAssessor',
  'tvApplicant',
  'tvOpinion',
  'tvFinal',
  'caseFacts',
];

export const apnList: any[] = [
    {
        apn: '222-333-444',
        strNum: '100',
        street: 'Main St',
        unit: '',
        city: 'Elk',
        taxRateArea: '069-016',
        useCode: '01',
        landValue: 250000,
        improvementValue: 410000,
        fixturesValue: 0,
    },
    {
        apn: '333-444-555',
        strNum: '300',
        street: 'Park Pl',
        unit: '',
        city: 'Albion',
        taxRateArea: '074-011',
        useCode: '01',
        landValue: 245000,
        improvementValue: 310000,
        fixturesValue: 0,
    },
    {
        apn: '444-555-666',
        strNum: '400',
        street: 'Madison Ave',
        unit: '',
        city: 'Casper',
        taxRateArea: '076-011',
        useCode: '01',
        landValue: 400000,
        improvementValue: 350000,
        fixturesValue: 0,
    },
    {
        apn: '334-445-556',
        strNum: '211',
        street: 'Prospect Pl',
        unit: '',
        city: 'Fort Bragg',
        taxRateArea: '032-011',
        useCode: '01',
        landValue: 245000,
        improvementValue: 440000,
        fixturesValue: 0,
    },
    {
        apn: '233-344-455',
        strNum: '221',
        street: 'Baker St',
        unit: '',
        city: 'Manchester',
        taxRateArea: '051-011',
        useCode: '17',
        landValue: 2110000,
        improvementValue: 1800000,
        fixturesValue: 59500,
    }

];

